/* Step 3 · rule 3 (B-3e) — the 105(a) figures are rounded on the server only (materiality.compute_derived). The panel asks the
   server for the calculated overall and PM / CT of the figures typed (POST …/materiality-figures/preview) and shows those
   numbers; it never rounds a percentage itself (before: JS Math.round here, Python round on save — a different last cent on a
   .5 edge). */
import api from "@/lib/api";

const num = (v) => Number(v || 0);

export function previewBody(doc) {
  const d = doc || {};
  return {
    benchmark_amount: num(d.benchmark_amount), pct_applied: num(d.pct_applied),
    overall_materiality: d.overall_materiality == null || d.overall_materiality === "" ? null : num(d.overall_materiality),
    pm_pct: num(d.pm_pct), ct_pct: num(d.ct_pct),
  };
}

export const previewKey = (doc) => JSON.stringify(previewBody(doc));

export async function fetchPreview(engagementId, doc) {
  const r = await api.post(`/engagements/${engagementId}/materiality-figures/preview`, previewBody(doc), { _silent: true });
  return r?.data || null;
}
